import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailInformationItemContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: ${10 * Screen.widthRatio}px;
`;

export default DetailInformationItemContainer;
